import { useCallback } from 'react';

import { useAtom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';
import { v4 as uuid } from 'uuid';

import type { Notification, NotificationType } from './types';

const notificationsAtom = atomWithStorage<Notification[]>(
  'notifications',
  [],
  createJSONStorage(() => sessionStorage),
  {
    getOnInit: true,
  }
);

interface NotificationOptions {
  isDismissable?: boolean;
}

interface UseNotificationsHookResult {
  showNotification: (type: NotificationType, message: string, options?: NotificationOptions) => void;
  dismissNotification: (id: string) => void;
  notifications: Notification[];
}

export function useNotifications(): UseNotificationsHookResult {
  const [notifications, setNotifications] = useAtom(notificationsAtom);

  const showNotification = useCallback((type: NotificationType, message: string, options: NotificationOptions = {}) => {
    const { isDismissable = true } = options;
    setNotifications(state => [...state, { type, message, id: uuid(), isDismissable }]);
  }, []);

  const dismissNotification = useCallback((id: string) => {
    setNotifications(state => state.filter(notification => notification.id !== id));
  }, []);

  return { notifications, showNotification, dismissNotification };
}
